import React from 'react';
import { createUseStyles } from 'react-jss';

const Loader = () => {
  const classes = useStyles();
  return (
    <div className={classes.loading} />
  );
};

const useStyles = createUseStyles({
  loading: {
    zIndex: '31',
    width: '32px',
    height: '32px',
    display: 'inline-block',
    borderRadius: '50%',
    minWidth: '18px',
    minHeight: '18px',
    maxWidth: '18px',
    maxHeight: '18px',
    border: '.25rem solid rgba(255, 255, 255, 0.2)',
    borderTopColor: '#FFFFFF',
    animation: '1s infinite linear',
    animationName: '$spin',
    borderStyle: 'double',
    borderWidth: '.5rem',
    marginRight: '0.4em',
  },

  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
});

export default Loader;

